import i18n, { InitOptions } from 'i18next';

import LngDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { loadTranslations } from '@justgiving/page-components';
import resourcesToBackend from 'i18next-resources-to-backend';

export const i18nOptions: InitOptions = {
  supportedLngs: ['en', 'en-GB'],
  fallbackLng: 'en',
  ns: [
    'activity',
    'campaignBranding',
    'campaignFundraisingPages',
    'campaignLandingPage',
    'campaignNavigation',
    'campaignOverview',
    'campaignScheduleOrPublish',
    'categories',
    'cause',
    'chooseCause',
    'chooseEvent',
    'claim',
    'common',
    'cover',
    'createYourCampaign',
    'crowdfundingCover',
    'crowdfundingPersonalise',
    'crowdfundingTarget',
    'fundraisingTypeSelection',
    'errorPage',
    'launch',
    'login',
    'occasion',
    'page-components-event',
    'pageBasics',
    'personalise',
    'target',
    'teamConnectPage',
    'teamConnectPageSuccess',
    'teamDetails',
    'teamInMemory',
    'teamOverview',
    'teamPersonalise',
    'teamTarget',
  ],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
    skipOnVariables: false,
  },

  detection: {
    order: ['querystring', 'navigator'],
    lookupQuerystring: 'locale',
  },
};

i18n
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      async (lang: string, namespace: string) =>
        (await loadTranslations(lang, namespace)) ??
        import(
          /* webpackChunkName: "lang/[request]" */ `../lang/${lang}/${namespace}.json5`
        )
    )
  )
  .use(LngDetector)
  .init(i18nOptions);

export default i18n;
